import { request } from "../api/axios";

function buildAuthHeaders(apiKey, organizationId) {
  const headers = {};
  if (apiKey) {
    headers["X-API-Key"] = apiKey;
  }
  if (organizationId) {
    headers["X-Organization-ID"] = organizationId;
  }
  return headers;
}

export const djangoApi = {
  validateApiKey: (apiKey) =>
    request({
      url: "/api/pdf2json/validate-key",
      params: { api_key: apiKey },
      headers: buildAuthHeaders(apiKey),
    }),
  processPdfAsyncVector: (apiKey, organizationId, formData) =>
    request({
      url: "/api/pdf2json/process-pdf-async-vector",
      method: "POST",
      headers: buildAuthHeaders(apiKey, organizationId),
      data: formData,
    }),
  listProcessed: (apiKey, organizationId, limit = 25) =>
    request({
      url: "/api/pdf2json/processed-results",
      params: { limit },
      headers: buildAuthHeaders(apiKey, organizationId),
    }),
  getProcessedDetail: (apiKey, organizationId, ulid) =>
    request({
      url: `/api/pdf2json/processed-results/${ulid}`,
      headers: buildAuthHeaders(apiKey, organizationId),
    }),
  listOrganizations: (apiKey) =>
    request({
      url: "/api/tenants/organizations/",
      headers: buildAuthHeaders(apiKey),
    }),
  listJsonTemplates: (apiKey, organizationId, limit = 100) =>
    request({
      url: "/api/pdf2json/json-templates",
      params: { limit },
      headers: buildAuthHeaders(apiKey, organizationId),
    }),
  createJsonTemplate: (apiKey, organizationId, payload) =>
    request({
      url: "/api/pdf2json/json-templates",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...buildAuthHeaders(apiKey, organizationId),
      },
      data: payload,
    }),
};
